import { render, staticRenderFns } from "./threads-chart.vue?vue&type=template&id=600748f2&"
import script from "./threads-chart.vue?vue&type=script&lang=js&"
export * from "./threads-chart.vue?vue&type=script&lang=js&"
import style0 from "./threads-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports